const validate = values => {
	const errors = {}
	if (!values.warranty_type) {
		errors.warranty_type = 'Este Campo es Obligatorio'
	}
	return errors
}
	
export default validate
  


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsWarrantyForm.js
 **/